import NoImage from "../../assets/images/No_Image_Available.jpg";
import TanzaniaImage from "../../assets/images/tanzania.jpg";
import KenyaImage from "../../assets/images/kenya.jpg";
import RwandaImage from "../../assets/images/rwanda.jpg";
import UgandaImage from "../../assets/images/uganda.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Navigation, EffectCoverflow } from "swiper/modules";
import { Link, useNavigate } from "react-router-dom";
import LazyImage from "../image/LazyLoadImage";

const HeroComponent = ({ destinations }) => {
  const navigate = useNavigate();
  const handleClick = (id) => {
    navigate(`destinations/${id}`);
  };

  const handleCountryClick = (countryCode) => {
    navigate(`/country/destinations/${countryCode}`);
  };

  // Define countries with their specific images and correct country codes
  const countries = [
    {
      id: 1,
      name: 'Tanzania',
      value: 'tz',
      image: TanzaniaImage
    },
    {
      id: 2,
      name: 'Kenya',
      value: 'ke',
      image: KenyaImage
    },
    {
      id: 3,
      name: 'Rwanda',
      value: 'rw',
      image: RwandaImage
    },
    {
      id: 4,
      name: 'Uganda',
      value: 'ug',
      image: UgandaImage
    }
  ];

  return (
    <div className="bg-custom-image min-h-[480px] lg:min-h-[650px] bg-cover bg-center rounded-lg relative w-full">
      <div className="absolute inset-0 bg-color-primary-dark2 opacity-30"></div>

      {/* Headline */}
      <div className="text-center pt-24 sm:pt-32 md:pt-36 relative z-10 px-4">
        <div className="text-3xl sm:text-5xl md:text-7xl font-bold text-white">
          Unleash the Hiker Within
        </div>
        <div className="my-6 sm:my-10 mx-auto w-[70%] text-lg sm:text-xl md:text-2xl lg:text-3xl text-white leading-relaxed">
          Our simple yet powerful belief that every individual, regardless of their hiking experience, possesses an innate ability to conquer the most challenging peak
        </div>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6">
          <div className="bg-color-primary-dark2 w-[70%] sm:w-[40%] md:w-[15%] py-3 md:py-5 text-white rounded-lg text-sm sm:text-base cursor-pointer text-center">
            <Link to="/events">Hike With Us</Link>
          </div>
          <div className="bg-white w-[70%] sm:w-[40%] md:w-[15%] py-3 md:py-5 text-color-primary-dark2 rounded-lg text-sm sm:text-base cursor-pointer text-center font-medium hover:bg-gray-100 transition-colors">
            <a
              href="https://www.instagram.com/mambahikers_gear_shop?igsh=MThtc28xdGNuaWNqcw== "
              target="_blank"
              rel="noopener noreferrer"
            >
              Shop With Us
            </a>
          </div>
        </div>
      </div>

      {/* Destination section */}
      <div className="absolute bottom-0 py-8 px-6 md:px-16 lg:px-32 flex flex-col md:flex-row justify-between items-center w-full z-10 space-y-6 md:space-y-0">
        <div class="absolute inset-0 bg-color-primary-dark1 opacity-40 "></div>
        <div className="md:flex-1 text-center md:text-left z-10">
          <div className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-3">
            Tanzania, Kenya, Rwanda & Uganda
          </div>
          <div className="text-color-white2 text-sm sm:text-base md:text-2xl">
            Explore the best hiking destinations across East Africa
          </div>
        </div>

        {/* DESTINATIONS */}
        <div className="md:flex-1 w-full md:w-auto overflow-hidden">
          <Swiper
            effect={"coverflow"}
            slidesPerView={1}
            breakpoints={{
              300: { slidesPerView: 2 },
              640: { slidesPerView: 2 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            spaceBetween={20}
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }}
            loop={true}
            autoplay={{
              delay: 5000,
              disableOnInteraction: true,
            }}
            navigation={true}
            modules={[EffectCoverflow, Autoplay, Navigation]}
          >
            {countries?.map((country, index) => (
              <SwiperSlide key={index}>
                <div
                  className="relative cursor-pointer"
                  onClick={() => handleCountryClick(country.value)}
                >
                  <LazyImage
                    src={country.image || NoImage}
                    className={
                      "h-48 sm:h-64 md:h-80 w-full object-cover rounded-lg shadow-md"
                    }
                  />

                  <div className="absolute bottom-4 left-4 text-white font-bold text-sm sm:text-base">
                    {country.name}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default HeroComponent;
